import React, { useState } from 'react';
import './widget-tabs-desktop.scss';
import classNames from 'classnames';
import WidgetTabsTab from '../widget-tabs-tab';
import WidgetTabsLabel from '../widget-tabs-label';
import WidgetTabsContent from '../widget-tabs-content';
import Box from 'atomic/box';

const WidgetTabs: React.FC<{ active?: number | null; }> = ({ children, active }) => {
    const [currentTab, setActiveTab] = useState(active || 0);
    const items: { label: any; content: any; }[] = [];

    React.Children.forEach(children, (child: any) => {
        if (child.type && child.props && child.type === WidgetTabsTab) {
            let label: unknown = null;
            let content: unknown = null;

            React.Children.forEach(child.props.children, (item) => {
                if (item.type === WidgetTabsLabel) {
                    label = item;
                }

                if (item.type === WidgetTabsContent) {
                    content = item;
                }
            });

            if (label && content) {
                items.push({
                    label,
                    content
                });
            }
        }
    });

    return (
        <Box className="w-section-tab-d" padding="lg">
            <div className="w-section-tab-d__navi">
                {items.map((item, index) => (
                    <button
                        key={`${index}-label`}
                        className={classNames({
                            'w-section-tab-d__navi-tab': true,
                            'w-section-tab-d__navi-tab--active': index === currentTab
                        })}
                        onClick={(): void => setActiveTab(index)}
                        title={item.label}
                    >
                        {item.label}
                    </button>
                ))}
            </div>
            <div className="w-section-tab-d__content">
                {
                    items.map((item, index) => (
                        <div
                            key={`${index}-content`}
                            className={classNames({
                                'w-section-tab-d__content-tab': true,
                                'w-section-tab-d__content-tab--active': index === currentTab
                            })}
                        >
                            {item.content}
                        </div>
                    ))
                }
            </div>
        </Box>

    );
};

export default WidgetTabs;
